import { useEffect } from "react";

export default function JsonLd({ data, id }) {
  useEffect(() => {
    const scriptId = id || `jsonld-${Math.random().toString(36).slice(2)}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.text = JSON.stringify(data);
    return () => { if (el && el.parentNode) el.parentNode.removeChild(el); };
  }, [data, id]);
  return null;
}

export const FAQS = [
  { q: "Hoe werkt het aanmelden van mijn woning bij Woon Verder?", a: "U meldt uw woning online aan met foto's en gegevens. Woon Verder controleert eerst uw aanvraag en publiceert pas na goedkeuring. Optioneel plannen we een fysieke intake-afspraak." },
  { q: "Wordt mijn woning automatisch gepubliceerd?", a: "Nee. Uw woning wordt NOOIT automatisch gepubliceerd. Woon Verder controleert altijd eerst uw gegevens en foto's. Pas na goedkeuring gaat de woning live." },
  { q: "Wat kost het om mijn woning te verkopen via Woon Verder?", a: "De aanmelding is gratis. Bij een succesvolle verkoop volgens de overeenkomst geldt 2,5% (excl. btw) van de gerealiseerde verkoopprijs." },
  { q: "Kan Woon Verder professionele foto's maken van mijn woning?", a: "Ja. Fotografie is een aparte betaalde service. U kunt dit aanvragen tijdens de aanmelding — wij plannen dan een fotograaf in." },
  { q: "Hoe vinden kopers de juiste woning?", a: "Kopers maken gratis een zoekprofiel aan met locatie, budget en wensen. Onze matching engine berekent voor elke woning een match-score en toont alleen relevante woningen." },
  { q: "Werkt Woon Verder alleen in Nederland?", a: "Nederland is onze launch-markt. Onze architectuur is meertalig (NL/EN/DE/ES) en klaar voor internationale uitbreiding naar België, Duitsland, Frankrijk, Spanje en verder." },
];
